// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"d906b377","59":"071dce59","162":"d9d514af","862":"2d05018d"}[chunkId] + ".chunk.css";
};